import {
  isReverificationHint,
  reverificationError,
  reverificationErrorResponse
} from "./chunk-43A5F2IE.mjs";
import "./chunk-7ELT755Q.mjs";
export {
  isReverificationHint,
  reverificationError,
  reverificationErrorResponse
};
//# sourceMappingURL=authorization-errors.mjs.map